import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "../../framework/helpers/BreakpointHelper";
import { FlexContainer } from "../../BaseComponents/Flex/FlexContainer";
import { Link } from "./../../BaseComponents/Link/Link";

export const BreadcrumbsLink = styled(Link).attrs(({ last, mobile, first, theme }) => ({
	color: last && !mobile && !first ? `${theme.colors.darkgrey}` : `${theme.colors.black}`,
}))`
	margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : "")};
	${media.greaterThan(breakpoints.mobile)`
		color: ${(color) => color};
		pointer-events: ${({ last }) => (last ? "none" : "")};
		font-size: 14px;
	`}
	${media.lessThan(breakpoints.mobile)`
    	font-weight: bold;
	`}
`;
